import deepmerge from 'deepmerge';
import BaseConfig from 'base/config';
import BrandConfig from '@/hant/config';

export default deepmerge(BaseConfig, BrandConfig);